import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { Document } from '@contentful/rich-text-types';

type FaqSingular = {
    question: string;
    answer: Document;
};

export const constructGoogleFaqSchema = (faqs: FaqSingular[]) => {
    let entity = '';

    faqs.forEach((i, index) => {
        entity =
            entity +
            `{
            "@type": "Question",
            "name": "${i.question}",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "${documentToPlainTextString(i.answer)}"
            }
        }${index + 1 === faqs.length ? `` : `,`}`;
    });

    const schema = `
    {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            ${entity}
        ]
    }
    `;

    return schema;
};
